/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { createStyledEditFieldProps } from "./styles";

// A Spanish field is only editable when its English counterpart has a value.
export const isEnglishValueBlank = (value) =>
  value === null || value === undefined || String(value).trim() === "";

// Disables a Spanish field and gives it the read-only look when English is blank.
export const createSpanishFieldProps = (englishValue, isReadOnly) => {
  const isBlank = isEnglishValueBlank(englishValue);

  return {
    disabled: isReadOnly || isBlank,
    ...createStyledEditFieldProps(isBlank),
  };
};
